import { FieldSet, Legend } from '../../../shared/components/Form/Form';
import { FieldBlurEvent, FieldProps, ObjectSchema } from '../../types';
import { orderProperties } from '../../validation/utils';
import Field from '../Field';
import styles from './ObjectField.module.css';
import { PopoverContainer } from '../../../pages/claimForms/components/PopoverContainer';

type ObjectFieldProps = FieldProps<ObjectSchema>;

export const ObjectField = ({
  onChange,
  onBlur,
  id,
  name,
  formName,
  value,
  schema,
  forceShowError,
  errors,
  touched,
  readOnly
}: ObjectFieldProps) => {
  const handleChange = (subField: string, subFieldValue: any) => {
    onChange({
      target: {
        name,
        value: {
          ...value,
          [subField]: subFieldValue
        }
      }
    });
  };

  const handleBlur = (e: FieldBlurEvent) => {
    onBlur({
      target: {
        name,
        touched: {
          ...touched,
          [e.target.name]: e.target.touched
        }
      }
    });
  };

  const $uiOptions = schema.$uiOptions || {};

  const properties = schema.properties || {};

  return (
    <FieldSet>
      <div style={{ display: 'flex', marginBottom: 8 }}>
        {schema.title && (
          <Legend
            style={!$uiOptions.hint ? { marginBottom: '16px' } : undefined}
          >
            {schema.title}
          </Legend>
        )}
        {schema.description && (
          <PopoverContainer id={id} description={schema.description} />
        )}
      </div>
      {$uiOptions.hint && (
        <div style={{ marginBottom: 24 }}>
          <span className="dsm-form-hint">{$uiOptions.hint}</span>
        </div>
      )}

      {orderProperties(Object.keys(properties), $uiOptions.propertyOrder).map(
        field => {
          const fieldName = `${name}_${field}`;
          const isFieldRequired = schema.required?.includes(field);
          return (
            <div className={styles.field} key={fieldName}>
              <Field
                schema={properties[field]}
                value={(value || {})[field]}
                id={`${id}_${field}`}
                errors={(errors || {})[field]}
                touched={(touched || {})[field]}
                name={fieldName}
                formName={formName}
                onChange={e => handleChange(field, e.target.value)}
                onBlur={e =>
                  handleBlur({
                    target: {
                      name: field,
                      touched: e.target.touched
                    }
                  })
                }
                forceShowError={forceShowError}
                readOnly={readOnly}
                isFieldRequired={isFieldRequired}
              />
            </div>
          );
        }
      )}
    </FieldSet>
  );
};
